import React from 'react';
import WalletContainer from './WalletContainer';

const WalletView = () => {
  return <WalletContainer />;
};

export default WalletView;
